module.exports = __webpack_public_path__ + "static/media/slogo-branca.73921585.png";